var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tile is-vertical"
  }, [_c('div', {
    staticClass: "tile is-parent",
    staticStyle: {
      "flex-grow": "unset"
    }
  }, [_c('div', {
    staticClass: "tile is-child"
  }, [_c('h1', {
    staticClass: "title is-3"
  }, [_vm._v("Nível " + _vm._s(_vm.nivel))])])]), _vm.premiadosNivel.hasOwnProperty('ouroEspecial') ? _c('PremiacaoPanel', {
    attrs: {
      "premiados": _vm.premiadosNivel.ouroEspecial,
      "medalha": "Ouro Especial",
      "ouro-especial": ""
    }
  }) : _vm._e(), _c('PremiacaoPanel', {
    attrs: {
      "premiados": _vm.premiadosNivel.ouro,
      "medalha": "Ouro",
      "ouro": ""
    }
  }), _c('PremiacaoPanel', {
    attrs: {
      "premiados": _vm.premiadosNivel.prata,
      "medalha": "Prata",
      "prata": ""
    }
  }), _c('PremiacaoPanel', {
    attrs: {
      "premiados": _vm.premiadosNivel.bronze,
      "medalha": "Bronze",
      "bronze": ""
    }
  }), _c('PremiacaoPanel', {
    attrs: {
      "premiados": _vm.premiadosNivel.mencaoHonrosa,
      "medalha": "Menção Honrosa"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };